import React from "react";
import EmployeeDetailPage from "./views/EmployeeDetailPage";
import EmployeeDetailPageContent from "../../constants/contentFile.json";
import { EmployeeDetailContextProvider } from "./EmployeeDetailView";
const EmployeeDetail = () => {
  return (
    <EmployeeDetailContextProvider>
      <EmployeeDetailPage
        textContents={EmployeeDetailPageContent.pageEmployeeDetail}
      />
    </EmployeeDetailContextProvider>
  );
};
export default EmployeeDetail;
